// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97eab437","239":"a2c57bb1","453":"22af96d5","455":"87cdc8fa"}[chunkId] + ".chunk.js";
};